module.exports = __webpack_public_path__ + "img/client15.937ee47c.webp";